$(document).ready(function() {
  $('.collapser, .js-collapser').once('sw-collapser').collapser();

  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        $(mutation.addedNodes).find('.collapser, .js-collapser').once('sw-collapser').collapser();
      }
    }
  });
  observer.observe(document, {
    subtree:true,
    childList:true,
  });

});

jQuery.fn.collapser = function (method) {
  switch (method) {
    case undefined:
      this.each(function () {
        const c = new Collapser($(this));
      });
      return this;
    case 'getObject':
      return this.eq(0).data('collapser');
    case 'open':
      this.each(function () {
        const c = $(this).collapser('getObject');
        if (c) {
          c.open();
        }
      });
      return this;
    case 'close':
      this.each(function () {
        const c = $(this).collapser('getObject');
        if (c) {
          c.close();
        }
      });
      return this;
  }
};

var Collapser = function($wrap) {
	var _this = this;

	this.$c = $wrap;
	this.$cc = this.$c.find('.collapser__content, .js-collapser__content');
	this.$t = this.$c.find('.collapser__title, .js-collapser__title');

	this.group = this.$c.data('collapser-group');

	this.$c.data('collapser', this);

  this.$t.on('click',function(e) {
    e.preventDefault();
    if ( _this.$c.hasClass('collapser--open')) {
      _this.close();
    } else {
      _this.open();
    }
  });

  this.$t.on('keyup',function(e) {
    if( e.keyCode === 13) {
      e.preventDefault();
      if ( _this.$c.hasClass('collapser--open') ) {
        _this.close();
      } else {
        _this.open();
      }
    }
  });


	setTimeout(function() {
    if ( Shopify.designMode ) {
      _this.open(1, 1);
    } else {
      if (_this.$c.hasClass('collapser--open')) {
        _this.open(1);
      } else {
        _this.close(1);
      }
    }
    _this.$c.addClass('collapser--initialized');
    $(window).resize();
	},1);
};
Collapser.prototype.open = function(no_anim, ignore_group) {
  const _this = this;
  if ( !ignore_group ) {
    var all = this.group_find();
    for (var i in all) {
      var c = all[i];
      if (c !== this) {
        c.close(no_anim);
      }
    }
  }
	if ( no_anim) {
		this.$cc.show();
	} else {
    this.$cc.slideDown(400);
	}
  this.$c.addClass('collapser--open');
  this.$c.trigger('sw-collapser-open');
};
Collapser.prototype.close = function(no_anim) {
	if ( no_anim) {
		this.$cc.hide();
	} else {
    this.$cc.slideUp(400);
	}
  this.$c.removeClass('collapser--open');
  this.$c.trigger('sw-collapser-close');
};
Collapser.prototype.group_find = function() {
	var collapsers = [];
  if ( this.group ) {
    $('.collapser,.js-collapser').filter('[data-collapser-group="' + this.group + '"]').each(function() {
      collapsers.push($(this).collapser('getObject'));
    });
  } else {
    this.$c.closest('.collapsers').find('.collapser').each(function() {
      collapsers.push($(this).collapser('getObject'));
    })
  }
	return collapsers;
};
